import { Scene } from 'phaser'
import small_1 from '@/game/puzzle/assets/images/block_1.png'
import small_2 from '@/game/puzzle/assets/images/block_2.png'
import small_3 from '@/game/puzzle/assets/images/block_3.png'
import small_4 from '@/game/puzzle/assets/images/block_4.png'
import small_5 from '@/game/puzzle/assets/images/block_5.png'
import small_6 from '@/game/puzzle/assets/images/block_6.png'
import tall from '@/game/puzzle/assets/images/tall_block.png'
import wide from '@/game/puzzle/assets/images/wide_block.png'
import player from '@/game/puzzle/assets/images/player_block.png'
import bgBorder from '@/game/puzzle/assets/images/bg_border.png'



export default class BootScene extends Scene {
  constructor () {
    super({ key: 'BootScene' })
  }

  preload () {
    this.load.image('smallBlock_1', small_1)
    this.load.image('smallBlock_2', small_2)
    this.load.image('smallBlock_3', small_3)
    this.load.image('smallBlock_4', small_4)
    this.load.image('smallBlock_5', small_5)
    this.load.image('smallBlock_6', small_6)
    this.load.image('tallBlock', tall)
    this.load.image('wideBlock', wide)
    this.load.image('playerBlock', player)
    this.load.image('backGround', bgBorder)
  }

  create () {
    this.scene.start('PlayScene')
  }
}
